import {
  RESEND_RESETPW_CODE_REQUESTING,
  RESEND_RESETPW_CODE_SUCCESS,
  RESEND_RESETPW_CODE_ERROR,
} from './constants'

const initialState = {
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
}

const reducer = function resendResetPwCodeReducer (state = initialState, action) {
  switch (action.type) {
    // Set the requesting flag and append a message to be shown
    case RESEND_RESETPW_CODE_REQUESTING:
      return {
        ...state,
        requesting: true,
        successful: false,
        messages: [],
        errors: [],
      }

    // Successful?  Reset the login state.
    case RESEND_RESETPW_CODE_SUCCESS: 
      return {
        ...state,
        errors: [],
        messages: [{ body: action.message, time: new Date() }],
        requesting: false,
        successful: true,
      }

    // Append the error returned from our api
    // set the success and requesting flags to false
    case RESEND_RESETPW_CODE_ERROR:
      return {
        ...state,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
        messages: [],
        requesting: false,
        successful: false,
      }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Pages/ResendResetPwCode/reducer.js